import { render, staticRenderFns } from "./SidebarDepentdent.vue?vue&type=template&id=36458d94"
import script from "./SidebarDepentdent.vue?vue&type=script&lang=js"
export * from "./SidebarDepentdent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports